import actions from '../../actionTypes';

export default tag => {
  return {
    type: actions.SET_CURRENT_TAG,
    tag
  };
};



// WEBPACK FOOTER //
// ./src/reducers/tags/actions/setCurrentTag.js